// GuidesLayout.jsx (v5)
import { useEffect, useState, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./doc.module.css"; // adjust path as needed

export default function GuidesLayout({ children }) {
  const { pathname } = useLocation();
  const [guides, setGuides] = useState([]);
  const [q, setQ] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [open, setOpen] = useState({});

  useEffect(() => {
    fetch("/learn.json").then(r => r.json()).then(setGuides);
  }, []);

  const filtered = guides
    .map(({ category, topics }) => ({
      category,
      topics: topics.filter(t =>
        t.name.toLowerCase().includes(q.toLowerCase()) ||
        t.keywords?.toLowerCase().includes(q.toLowerCase()) ||
        t.subTopics?.some(s => s.name.toLowerCase().includes(q.toLowerCase()))
      )
    }))
    .filter(({ topics }) => topics.length > 0);

  const toggle = (key) => setOpen(prev => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className={styles.container}>
    <div className={styles.mainContent}>
      <div className={styles.firstbg} />
      <div className={styles.secondbg} />

      <div className={`${styles.sidebarContainer} ${sidebarOpen ? styles.scbShow : ""}`}>
        <nav className={styles.sidebar}>
          <label className={styles.searchBar}>
            {/* replace with your icon */}
            <span className={styles.icn}>🔎</span>
            <input
              type="text"
              placeholder="Search..."
              className={styles.searchInput}
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </label>

          {filtered.map(({ category, topics }) => (
            <Fragment key={category}>
              <h6>{category.replace(/-/g, " ")}</h6>
              <ul>
                {topics.map((t) => {
                  const isActive = pathname.includes(t.link);
                  const hasSubs = !!t.subTopics?.length;
                  return (
                    <li key={t.link}>
                      <Link
                        to={t.link}
                        className={`${isActive ? styles.active : ""} ${hasSubs ? styles.hasSubTopics : ""}`}
                        onClick={(e) => {
                          if (hasSubs) {
                            e.preventDefault();
                            toggle(t.name);
                          } else {
                            setSidebarOpen(false);
                          }
                        }}
                      >
                        {t.name}
                        {hasSubs && <span>{open[t.name] ? "▾" : "▸"}</span>}
                      </Link>

                      {hasSubs && open[t.name] && (
                        <ul className={styles.subNav}>
                          {t.subTopics.map((s) => (
                            <li key={s.link}>
                              <Link
                                to={s.link}
                                className={pathname.includes(s.link) ? styles.active : ""}
                                onClick={() => setSidebarOpen(false)}
                              >
                                {s.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            </Fragment>
          ))}
        </nav>
      </div>

      <div
        className={`${styles["sidebar-backdrop"]} ${sidebarOpen ? styles.scbShow : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      <main className={styles.content}>
        <div className={styles.menu}>
          <button onClick={() => setSidebarOpen(p => !p)}>☰</button>
        </div>
        {children}
      </main>
    </div>
    </div>
  );
}